import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'

export const ClusterSupportApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  const app = apps[AppId.CLUSTER_SUPPORT]

  return (
    <FullPageAppTemplate
      appId={AppId.CLUSTER_SUPPORT}
      scope='cluster_support'
      envKey={app?.runtimeEnvKey}
      entryPath='./ClusterSupportApp'
      url={process.env.REACT_APP_CLUSTER_SUPPORT_APP_DEV_PATH}
      appName={app?.name ?? 'Cluster Support'}
      appProps={{
        user,
        initialPath: app?.path ?? '/cluster-support',
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
